(() => {
  const init = (root) => {
    if (!root || root.dataset.ivnoInitialized === 'true') return;
    root.dataset.ivnoInitialized = 'true';
    root.dataset.ivnoEnhanced = 'true';

    const items = root.querySelectorAll('.ivno-reveal');
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    items.forEach((item) => observer.observe(item));
  };

  const boot = () => document.querySelectorAll('[data-ivno-home]').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target.querySelector('[data-ivno-home]'));
  });
})();
